var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("c-tab", {
        ref: "ctomissTab",
        attrs: {
          type: "horizon",
          inlineLabel: true,
          dense: true,
          height: _vm.tabHeight,
          tabItems: _vm.tabItems,
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (tab) {
              return [
                _c(tab.component, {
                  tag: "component",
                  attrs: {
                    popupParam: _vm.popupParam,
                    investigation: _vm.investigation,
                    heavyWorks: _vm.heavyWorks,
                    attachInfo: _vm.attachInfo,
                    contentHeight: _vm.contentHeight,
                    disabled: _vm.disabled,
                    isOld: _vm.isOld,
                  },
                  on: {
                    "update:popupParam": function ($event) {
                      _vm.popupParam = $event
                    },
                    "update:popup-param": function ($event) {
                      _vm.popupParam = $event
                    },
                    "update:investigation": function ($event) {
                      _vm.investigation = $event
                    },
                    "update:heavyWorks": function ($event) {
                      _vm.heavyWorks = $event
                    },
                    "update:heavy-works": function ($event) {
                      _vm.heavyWorks = $event
                    },
                    "update:attachInfo": function ($event) {
                      _vm.attachInfo = $event
                    },
                    "update:attach-info": function ($event) {
                      _vm.attachInfo = $event
                    },
                    "update:disabled": function ($event) {
                      _vm.disabled = $event
                    },
                    "update:isOld": function ($event) {
                      _vm.isOld = $event
                    },
                    "update:is-old": function ($event) {
                      _vm.isOld = $event
                    },
                    getDetail: _vm.getDetail,
                    closePopup: _vm.closePopup,
                  },
                }),
              ]
            },
          },
        ]),
        model: {
          value: _vm.tab,
          callback: function ($$v) {
            _vm.tab = $$v
          },
          expression: "tab",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }